"use client";

import { buildRequestHeaders } from "@datocms/cda-client";
import { cacheExchange, Client, fetchExchange, Provider } from "urql";

import { env } from "~/env";

// Dato CMS Client
const datoClient = new Client({
  url: "https://graphql.datocms.com",
  exchanges: [cacheExchange, fetchExchange],
  fetchOptions: {
    headers: buildRequestHeaders({
      token: env.NEXT_PUBLIC_DATOCMS_API_TOKEN,
      includeDrafts: env.NEXT_PUBLIC_VERCEL_URL !== "www.triptojapan.com",
      excludeInvalid: true,
      returnCacheTags: false,
    }),
  },
});

export function UrqlProvider({ children }: { children: React.ReactNode }) {
  return <Provider value={datoClient}>{children}</Provider>;
}
